import session from "../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../services/api";

const AdminApiService = new AdminApi()
export default {
    data() {
        return {
            filter: '',
            model: []
        }
    },
    computed: {
        filteredTerms() {
            let _self = this;
            return this.model.filter(item => {
                let item2 = _self.convertDayToRs(item.day)
                let filterList = this.filter.split(" ");
                if(filterList.length === 1){
                    let filter1 = filterList[0];
                    return item.startAt.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter1.toLowerCase()) > -1
                }else if(filterList.length === 2){
                    let filter1 = filterList[0];
                    let filter2 = filterList[1];
                    return (item.startAt.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter1.toLowerCase()) > -1)
                            && (item.startAt.toLowerCase().indexOf(filter2.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter2.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter2.toLowerCase()) > -1)
                }else if(filterList.length === 3){
                    let filter1 = filterList[0];
                    let filter2 = filterList[1];
                    let filter3 = filterList[2];
                    return (item.startAt.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter1.toLowerCase()) > -1)
                        && (item.startAt.toLowerCase().indexOf(filter2.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter2.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter2.toLowerCase()) > -1)
                        && (item.startAt.toLowerCase().indexOf(filter3.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter3.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter3.toLowerCase()) > -1)
                }else {
                    return item.startAt.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 || item2.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
                }
            })
        }
    },
    methods: {
        load: load,
        convertDayToRs: convertDayToRs,
        addTerm: addTerm,
        editTerm: editTerm,
        deleteTerm: deleteTerm,
        createSlots: createSlots,
        deleteFiltered: deleteFiltered
    },
    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/home');
            return;
        }

        this.load()
    }
}

function load() {
    let _self = this;
    AdminApiService.getTerms()
        .then((response) => {
            _self.model = response.data;

        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function addTerm() {
  this.$router.push('add-term')
}

function editTerm(term) {
    this.$router.push('edit-term?id='+term.id)
}

function deleteTerm(term) {
    let _self = this;

    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete termin: "+convertDayToRs(term.day)+' '+term.startAt,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteTerm(term.id)
            .then((response) => {
                swal('Uspešno','Termin uspešno obirsan', 'success')
                _self.load()
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function createSlots() {
    this.$router.push('open-terms')
}

function convertDayToRs(day) {
    switch (day) {
        case 'MONDAY':
            return 'Ponedeljak'
        case 'TUESDAY':
            return 'Utorak'
        case 'WEDNESDAY':
            return 'Sreda'
        case 'THURSDAY':
            return 'Cetvrtak'
        case 'FRIDAY':
            return 'Petak'
        case 'SATURDAY':
            return 'Subota'
        case 'SUNDAY':
            return 'Nedelja'
    }
}

function deleteFiltered() {
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete pronadjene termine: ",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        let ids = _self.filteredTerms.map(x => x.id)
        AdminApiService.deleteTerms(ids)
            .then((response) => {
                swal('Uspešno','Termin uspešno obirsani termini', 'success')
                _self.load()
                _self.filter = ""
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}


// WEBPACK FOOTER //
// ./src/components/Term/Term.js